import { render, staticRenderFns } from "./BadgeShopList.vue?vue&type=template&id=01f62492&scoped=true&"
import script from "./BadgeShopList.vue?vue&type=script&lang=js&"
export * from "./BadgeShopList.vue?vue&type=script&lang=js&"
import style0 from "./BadgeShopList.vue?vue&type=style&index=0&id=01f62492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f62492",
  null
  
)

export default component.exports